import React, { ReactNode } from 'react'

import styles from './index.module.css'
import Typography from '../Typography'
import { cn, type UtilityClassNames } from '@s4l/utility-css'

export interface ITagProps {
  /**
   * Default: var(--color-base-white)
   */
  color?: string
  /**
   * Default: var(--color-success-500)
   */
  bgColor?: string
  children: React.ReactNode
  icon?: ReactNode
  /**
   * Default s
   */
  size?: 's' | 'm' | 'l'

  /**
   * Default plain
   */
  variant?: 'rounded' | 'plain'

  capitalizeFirst?: boolean

  className?: UtilityClassNames
}

function Tag(props: ITagProps) {
  const {
    children,
    color = 'var(--color-base-white)',
    bgColor = 'var(--color-success-500)',
    icon,
    size = 's',
    variant = 'plain',
    capitalizeFirst = false,
    className,
  } = props

  const typographyProps = {
    variant: size === 'l' ? 'body' : 'caption',
    size: size === 's' ? 'm' : 'l',
    bold: true,
    capitalizeFirst,
  } as const

  return (
    <div
      data-testid="tag"
      className={cn(styles.tag, { [styles.rounded]: variant === 'rounded' }, className)}
      style={
        {
          '--tag-color': color,
          '--tag-bg-color': bgColor,
        } as React.CSSProperties
      }
      data-size={size}
    >
      {icon}
      <Typography {...typographyProps}>{children}</Typography>
    </div>
  )
}

export default Tag
